var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),(
    _vm.resource.idEstatusSolicitud === 1 ||
    _vm.resource.idEstatusSolicitud === 2
  )?_c('router-link',{attrs:{"to":{
    name: 'CotizacionCajaPti',
    params: {
      idPti: _vm.data.item.idPti,
      idRecibo: _vm.data.item.idRecibo,
      idSesion: _vm.data.item.idSesion,
      idSolicitud: _vm.data.item.idSolicitudDiagnostico,
      idTipoSolicitud: _vm.data.item.idTipoSolicitud,
    },
  }}},[_c('p',{staticClass:"letraColorAzulPrincipal letraEstiloNegrita",on:{"click":function($event){return _vm.putCambiarEstatusSolicitud(_vm.data.item.idSolicitudBandejaCobro, _vm.resource.idEstatusSolicitud)}}},[_vm._v(" "+_vm._s(_vm.data.item.nombrePaciente)+" ")])]):_c('router-link',{attrs:{"to":{
    name: 'paciente',
    params: { id: _vm.data.item.idPaciente },
  }}},[_c('p',{staticClass:"letraColorAzulPrincipal letraEstiloNegrita"},[_vm._v(" "+_vm._s(_vm.data.item.nombrePaciente)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }